module.exports = {
    // base_url: 'http://wellworld.id:12095'
    // base_url: 'https://danamon-api.komunestudio.com',
    // multiplayer_server_url: 'https://expo3d-server.intellivent.id',
    // multiplayer_server_url: 'https://socket-multi-dev.komunestudio.com',
    // base_url: 'https://api.danamonlearningfest.id'
}
